<template>
    <div class="border m-4 p-16 rounded text-xl">
        {{ $t('login.logout.in.progress') }}
    </div>
</template>
<script>
export default {
    data() {
        return {
            fromRouteName: undefined
        };
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.fromRouteName = from.name;
        });
    },
    async created() {
        let cmpyEmailTknNum = this.$store.state.user?.cmpyEmailTknNum;

        let [result] = await Promise.all([
            this.$store.dispatch('logout'),
            new Promise(rs => setTimeout(rs, 800))
        ]);
        if (result.success) {
            this.$router.push(
                this.fromRouteName === 'companyQuickJoin'
                    ? {
                          name: 'bofLogin'
                      }
                    : {
                          path: cmpyEmailTknNum
                              ? `/previewProducts/${cmpyEmailTknNum}`
                              : '/login'
                      }
            );
        }
    }
};
</script>
